import { appendF2FCallHistory } from "../../helpers/array/array";
import {
  FACE_2_FACE_SESSION,
  FACE_TO_FACE_SESSION_FAILURE,
  FACE_TO_FACE_SESSION_SUCCESS,
  FACE_2_FACE_SESSION_CREATE,
  FACE_2_FACE_SESSIONCREATE_SUCCESS,
  FACE_2_FACE_SESSION_FAILURE,
  GET_SINGLE_SESSION,
  GET_SINGLE_SESSION_SUCCESS,
  GET_SINGLE_SESSION_FAILURE,
  FACE_TO_FACE_CALL_HISTORY,
  FACE_TO_FACE_CALL_HISTORY_SUCCESS,
  FACE_TO_FACE_CALL_HISTORY_FAILURE,
  FETCH_F2F_PENDING_CALLS_START,
  FETCH_F2F_PENDING_CALLS_SUCCESS,
  FETCH_F2F_PENDING_CALLS_FAILURE
} from "../../store/actions/ActionConstant";

export const initialState = {
  session: {
    data: {},
    loading: false,
    error: false,
  },
  callHistoryData: {
    data: {
      callHistory: [],
      pagination: {}
    },
    loading: false,
    error: null,
  },
  new_session: {
    data: {},
    loading: false,
    error: false,
  },
  single_session: {
    data: {},
    loading: false,
    error: false,
    session_id: ''
  },
  pending_calls: {
    data: {},
    loading: false,
    error: false,
  }
};

const Face2FaceSessionReduer = (state = initialState, action) => {
  switch (action.type) {
    case FACE_2_FACE_SESSION:
      return {
        ...state,
        session: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FACE_TO_FACE_SESSION_FAILURE:
      return {
        ...state,
        session: {
          data: action.data,
          loading: false,
          error: true,
        },
      };
    case FACE_TO_FACE_SESSION_SUCCESS:
      return {
        ...state,
        session: {
          data: action.data,
          loading: false,
          error: false,
        },
      };

    case FACE_2_FACE_SESSION_CREATE:
      return {
        ...state,
        new_session: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FACE_2_FACE_SESSIONCREATE_SUCCESS:
      return {
        ...state,
        get_new_session: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FACE_2_FACE_SESSION_FAILURE:
      return {
        ...state,
        get_new_session: {
          data: action.data,
          loading: false,
          error: true,
        },
      };


    case GET_SINGLE_SESSION:
      return {
        ...state,
        single_session: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case GET_SINGLE_SESSION_SUCCESS:
      return {
        ...state,
        single_session: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case GET_SINGLE_SESSION_FAILURE:
      return {
        ...state,
        single_session: {
          data: action.data,
          loading: false,
          error: true,
        },
      };

    case FETCH_F2F_PENDING_CALLS_START:
      return {
        ...state,
        pending_calls: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_F2F_PENDING_CALLS_SUCCESS:
      return {
        ...state,
        pending_calls: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_F2F_PENDING_CALLS_FAILURE:
      return {
        ...state,
        pending_calls: {
          data: action.data,
          loading: false,
          error: true,
        },
      };
      case FACE_TO_FACE_CALL_HISTORY:
        return {
          ...state,
          callHistoryData: {
            ...state.callHistoryData,
            error: false,
            loading: true,
          },
        };
      case FACE_TO_FACE_CALL_HISTORY_SUCCESS:
        return {
          ...state,
          callHistoryData: {
            data: {
              callHistory: appendF2FCallHistory(state.callHistoryData?.data?.callHistory || [], action?.data),
              pagination: action?.data?.pagination
            },
            error: false,
            loading: false,
          },
        };
      case FACE_TO_FACE_CALL_HISTORY_FAILURE:
        return {
          ...state,
          callHistoryData: {
            ...state.callHistoryData,
            error: action.data,
            loading: false,
          },
        };

    default:
      return state;

  };
}

export default Face2FaceSessionReduer;
